var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.plan.selectFeatures || []).length > 0
    ? _c(
        "div",
        { staticClass: "card-select-feature" },
        [
          _c(
            "a-select",
            {
              attrs: { dropdownClassName: "select-feature-dropdown" },
              model: {
                value: _vm.cloneSelectedFeatureIndex,
                callback: function ($$v) {
                  _vm.cloneSelectedFeatureIndex = $$v
                },
                expression: "cloneSelectedFeatureIndex",
              },
            },
            _vm._l(_vm.plan.selectFeatures, function (selectFeature, index) {
              return _c(
                "a-select-option",
                {
                  key: index,
                  class: {
                    "has-active-tick": _vm.isFeatureActive(selectFeature.count),
                  },
                  attrs: { value: index, disabled: selectFeature.isDisabled },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getOptionText(selectFeature.count)) +
                      "\n        "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.period !== "monthly" && _vm.getTotalPlanCount() > 0
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        content: _vm.$t("billing.activePlanCountTooltip", {
                          count: _vm.getTotalPlanCount(),
                        }),
                      },
                      expression:
                        "{ content: $t('billing.activePlanCountTooltip', { count: getTotalPlanCount() }) }",
                    },
                  ],
                  staticClass: "active-tier-badge-inline",
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.getTotalPlanCount()) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }